import { Popover, FloatButton } from "antd";
import React from "react";
import { Row, Col } from "antd";
import usFlag from "../assets/us.svg";
import frFlag from "../assets/fr.svg";

const CountryButton = ({country, setCountry}) => {
  return (
    <>
      <Popover
        placement="left"
        content={
        <Row gutter={8}>
          <Col span={12}>
            <img src={usFlag} alt="us" onClick={() => setCountry("us")} style={{ width: 32, opacity: country === "us" ? 1 : 0.4, border: country === "us" ? "2px solid black" : "", borderRadius: 100, cursor: "pointer" }}/>
          </Col>
          <Col span={12}>
            <img src={frFlag} alt="fr" onClick={() => setCountry("fr")} style={{ width: 32, opacity: country === "fr" ? 1 : 0.4, border: country === "fr" ? "2px solid black" : "", borderRadius: 100, cursor: "pointer" }}/>
          </Col>
        </Row>
        }
      >
        <FloatButton style={{padding: 0}} icon={<img src={country === "us" ? usFlag : frFlag} alt="us" style={{ width: 18 }}/>}></FloatButton>
      </Popover>
    </>
  );
};

export default CountryButton;
